import * as $ from 'jquery';
import 'jquery-datetimepicker/build/jquery.datetimepicker.full.min.js';
import 'jquery-datetimepicker/build/jquery.datetimepicker.min.css';

export default (function () {
  
  $.datetimepicker.setLocale('nl');


  if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1)
  {
    $('[type="date"]').datetimepicker({
      timepicker: false,
      format: 'Y-m-d'
    }).attr('autocomplete', "off");
  }


  $('.date').datetimepicker({
    timepicker: false,
    format: 'Y-m-d'
  }).attr('autocomplete', "off");

  $('.date-time').datetimepicker({
    format:'Y-m-d H:i'
  }).attr('autocomplete', "off");

  $('.time').datetimepicker({
    datepicker: false,
    format:'H:i'
  }).attr('autocomplete', "off");
}())
